module.exports = __webpack_public_path__ + "img/Fahrzeugfunkgerät_digital.94eb460f.svg";